import * as constants from '../constants';

const getUserLevelAvatar = officerLevel => {
  switch (officerLevel) {
    case constants.officerLevels.LEVEL_1.value:
      return 1;
    case constants.officerLevels.LEVEL_2.value:
      return 2;
    case constants.officerLevels.LEVEL_3.value:
      return 3;
    default:
      return '?';
  }
};

export default getUserLevelAvatar;